import * as React from "react";

import "./TopHeader.scss";

import logo from "../Images/microsoft-logo-only.png";

import { getProductName } from "../configuration";
import { getRootUrl } from "../routing";

import Navigation from "./Navigation";

import { Callout, ContentJustification, ContentLocation, ContentOrientation } from "azure-devops-ui/Callout";
import { FocusZone, FocusZoneKeyStroke } from "azure-devops-ui/FocusZone";
import { isArrowKey, KeyCode } from "azure-devops-ui/Util";

interface ITopHeaderState {
    menuOpen?: boolean;
}

class TopHeader extends React.Component<{}, ITopHeaderState> {
    constructor(props: {}) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <>
                <div className="top-header flex-row flex-center">
                    <div className="skinny-header-container flex-row flex-center">
                        <div tabIndex={0} className="skinny-menu-button" onClick={this.onMenuClick} onKeyDown={this.onMenuKeyDown}>
                            <svg aria-hidden="true" width="32" height="32" viewBox="0 0 32 32">
                                <path d="M32 10H0V8h32v2zm0 16H0v-2h32v2zm0-8H0v-2h32v2z" fillRule="evenodd" />
                            </svg>
                        </div>
                        <a aria-label="Home" href={getRootUrl() || "/"} className="skinny-logo-link">
                            <img alt="Home" className="skinny-logo-image" src={logo} />
                        </a>
                    </div>
                    <div className="header-title">{getProductName()}</div>
                </div>
                {this.state.menuOpen && (
                    <Callout
                        className="nav-menu-panel"
                        contentClassName="nav-menu-panel-content relative scroll-auto flex-grow"
                        contentJustification={ContentJustification.Stretch}
                        contentLocation={ContentLocation.Start}
                        contentOrientation={ContentOrientation.Column}
                        contentShadow={true}
                        escDismiss={true}
                        lightDismiss={true}
                        modal={false}
                        onDismiss={this.onMenuDismiss}
                    >
                        <FocusZone
                            circularNavigation={true}
                            defaultActiveElement=".nav-item-container"
                            focusOnMount={true}
                            handleTabKey={true}
                            includeDefaults={true}
                            preprocessKeyStroke={this.preProcessKeyStroke}
                        >
                            <div className="flex-column flex-grow">
                                <Navigation onNavigate={this.onMenuDismiss} expandAll={true} />
                            </div>
                        </FocusZone>
                    </Callout>
                )}
            </>
        );
    }

    private preProcessKeyStroke = (event: React.KeyboardEvent<HTMLElement>) => {
        return isArrowKey(event) ? FocusZoneKeyStroke.IgnoreParents : FocusZoneKeyStroke.IgnoreNone;
    };

    private onMenuKeyDown = (ev: React.KeyboardEvent): void => {
        if (ev.keyCode === KeyCode.enter || ev.keyCode === KeyCode.space || ev.keyCode === KeyCode.downArrow) {
            this.onMenuClick();
            ev.preventDefault();
        }
    };

    private onMenuClick = (): void => {
        this.setState({ menuOpen: !this.state.menuOpen });
    };

    private onMenuDismiss = (): void => {
        this.setState({ menuOpen: false });
    };
}

export default TopHeader;
